/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import { ListeTrimestre } from '@/types';

const OPTIONS_TRIMESTRE: Record<'key' | 'text' | 'value', string | number>[] = [
  {
    key: 1,
    text: ListeTrimestre.premierTrimestre,
    value: 1,
  },
  {
    key: 2,
    text: ListeTrimestre.deuxiemeTrimestre,
    value: 2,
  },
  {
    key: 3,
    text: ListeTrimestre.troisiemeTrimestre,
    value: 3,
  },
  {
    key: 4,
    text: ListeTrimestre.quatriemeTrimestre,
    value: 4,
  },
];

export default OPTIONS_TRIMESTRE;
